import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { useForm } from "react-hook-form";
import { AiOutlineSearch } from "react-icons/ai";
import { FaUserEdit } from "react-icons/fa";
import { IoEyeSharp } from "react-icons/io5";
import ModalImage from "react-modal-image";
import { AddButton, SubTitle } from "../../Components/CustomComponents";
import CustomSpinner from "../../Components/CustomComponents/CustomSpinner";
import AddSuperVisorModal from "../../Components/Modals/AddSupervisorModal";
import ChangePasswordModal from "../../Components/Modals/changePassModal";
import DeleteModal from "../../Components/Modals/DeleteModal";
import ViewSuperVisorDetailModal from "../../Components/Modals/ViewSuperVisorDetailModal";
import Table from "../../Components/Table/Table";
import {
  useAddSuperVisorMutation,
  useDeleteSuperVisorMutation,
  useGetAllSuperVisorQuery,
  useUpdateSuperVisorMutation,
} from "../../Data/services/supervisorApi";
import { MdDeleteOutline } from "react-icons/md";
import {
  useBlockUserMutation,
  useChangeUserPassMutation,
  useUnBlockUserMutation,
} from "../../Data/services/userApi";
import Toast from "../../Hooks/useToast";
import styles from "./styles/index.module.scss";
import { ROUTES } from "./Routes";

const SupervisorManagement = ({
  setPage,
  setSelectedRow,
  setPageName,
  setSupervisor,
}) => {
  const { control, handleSubmit, setValue, watch, reset } = useForm({
    defaultValues: { links: [{ title: "", link: "" }] },
  });

  const username = watch("username");
  const mobile_no = watch("mobile_no");

  console.log(username, mobile_no, "9999");

  const [indicationMessage, setIndicationMessage] = useState("No Data Found");
  const [editedData, setEditedData] = useState("");
  const [editedModal, setEditedModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo
  const [rowData, setRowData] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [finalImage, setFinalImage] = useState(null);
  const [learningMatData, setLearningMatData] = useState([]);
  const [blockModal, setBlockModal] = useState(false);
  const [changePassModal, setChangePassModal] = useState(false);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllSuperVisorQuery(
      {
        search: searchQuery || "",
        limit: pageSize || 10,
        page: currentPage || 1,
      },
      { refetchOnMountOrArgChange: true }
    );

  const [
    changeUserPass,
    {
      isSuccess: isSuccessChangePass,
      isLoading: isLoadingChangePass,
      isError: isErrorChangePass,
    },
  ] = useChangeUserPassMutation();
  const [
    blockUser,
    {
      isSuccess: isSuccessBlock,
      isLoading: isLoadingBlock,
      isError: isErrorBlock,
    },
  ] = useBlockUserMutation();
  const [
    unBlockUser,
    {
      isSuccess: isSuccessUnBlock,
      isLoading: isLoadingUnBlock,
      isError: isErrorUnBlock,
    },
  ] = useUnBlockUserMutation();

  const [addSuperVisor, { isLoading: isLoadingAdd }] =
    useAddSuperVisorMutation();

  const [updateSuperVisor, { isLoading: isLoadingUpdate }] =
    useUpdateSuperVisorMutation();
  const [deleteApi, { isLoading: isLoadingDelete }] =
    useDeleteSuperVisorMutation();

  useEffect(() => {
    if (data) {
      setPageSize(data?.links?.per_page);
      setCurrentPage(data?.links?.current);
      setTotalRecords(data?.links?.total_records);
      setTotalPages(data?.links?.total);
      setRowData(data?.data);
      setDataFetched(true);
    }
    if (data?.data?.length == 0) {
      setIndicationMessage("No Data available");
    }
  }, [data]);
  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  const handleViewModalOpen = () => {
    setViewModal(true);
  };
  const handleEditModalOpen = () => {
    setEditedModal(true);
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const onUpdateSuperVisor = async (data) => {
    if (data?.username === username) {
      delete data["username"];
    }
    if (data?.mobile_no === mobile_no) {
      delete data["mobile_no"];
    }

    try {
      let response = await updateSuperVisor({
        id: editedData?.id,
        modifiedData: data,
      }).unwrap();
      setEditedModal(false);
      setEditedData(null);
      // refetch();
      Toast(response?.message, "success");
    } catch (error) {
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  const onAddSuperVisor = async (data) => {
    try {
      let response = await addSuperVisor(data).unwrap();
      setAddModal(false);
      // refetch();
      Toast(response?.message, "success");
    } catch (error) {
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };
  const handleDelete = async () => {
    try {
      let response = await deleteApi(editedData?.id).unwrap();

      Toast(response?.message, "success");
      setDeleteModal(false);
      refetch();
    } catch (error) {
      console.log(error, "error");

      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error", error);
      }
    }
  };
  const onChangePassSubmit = async (data) => {
    try {
      let response = await changeUserPass({
        data: data,
        id: editedData?.id,
      }).unwrap();
      Toast(response?.message, "success");
      setChangePassModal(false);
    } catch (error) {
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  const columns = [
    {
      dataField: "image_url",
      text: "Image",
      // sort: true,
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => (
        <>
          <ModalImage
            small={"/placeholder.png"}
            large={"/placeholder.png"}
            alt="Hello World!"
            className={`${showImage ? "modal-image" : "column-image"}`}
            onClick={() => setShowImage(true)}
          />
        </>
      ),
    },
    {
      dataField: "firstname",
      text: "Name",
      // sort: true,
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => (
        <div className="lc-2">
          {row?.firstname && row?.lastname
            ? `${row?.firstname} ${row?.lastname}`
            : "-"}
        </div>
      ),
    },
    {
      dataField: "username",
      text: "User Name",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
      formatter: (cellContent, row) => <div>{row?.username || "-"}</div>,
    },
    {
      dataField: "mobile_no",
      text: "Mobile Number",
      // sort: true,
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => <div>{`+${row?.mobile_no}` || "-"}</div>,
    },
    {
      dataField: "email",
      text: "Email",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
      formatter: (cellContent, row) => <div>{row?.email || "-"}</div>,
    },
    {
      dataField: "total_routes",
      text: "Total Routes",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
      formatter: (cellContent, row) => <div>{row?.total_routes || "0"}</div>,
    },
    {
      dataField: "total_users",
      text: "Total Users",
      // sort: true,
      headerStyle: {
        width: "250px",
      },
      formatter: (cellContent, row) => <div>{row?.total_users || "0"}</div>,
    },
    {
      dataField: "is_blocked",
      text: "Block Status",
      sort: true,
      headerStyle: {
        width: "250px",
      },
      formatter: (cellContent, row) => {
        return (
          <span
            className={`${
              row?.is_blocked ? "badge bg-danger" : "badge bg-success"
            }`}
          >
            {row?.is_blocked ? "Blocked" : "Active"}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Action",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "250px",
      },
      formatter: (cellContent, row) => {
        if (row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <div
                className={`${styles.btnBgView} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 `}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  setViewModal(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center`}
                >
                  <IoEyeSharp color="black" />
                </span>
              </div>

              <div
                className={`${styles.btnBg} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 `}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleEditModalOpen(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center`}
                >
                  <FaUserEdit />
                </span>
              </div>
              <Dropdown className={`d-inline mx-2 ${styles.choice}`}>
                <Dropdown.Toggle
                  id="dropdown-autoclose-true"
                  className="primary-btn"
                >
                  {/* <IoEllipsisVertical /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setBlockModal(true);
                    }}
                  >
                    {row?.is_blocked ? "UnBlock" : "Block"}
                  </Dropdown.Item>
                  {/* <Dropdown.Item href="#" onClick={() => handleUnBLockUser(row)}>UnBlock</Dropdown.Item> */}
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setChangePassModal(true);
                    }}
                  >
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setPage(ROUTES.SUPERVISOR_ROUTES);
                      setSupervisor(row);
                    }}
                  >
                    Supervisor Routes
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div
                className={`${styles.btnBg} ${styles.bgDelete} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 `}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  setDeleteModal(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center`}
                >
                  <MdDeleteOutline />
                </span>
              </div>
            </div>
          );
        }
      },
    },
  ];
  const handleBlockModalClose = () => {
    setBlockModal(false);
    setEditedData("");
  };
  const blockUnblockSubmit = async () => {
    let response;
    try {
      if (editedData.is_blocked) {
        response = await unBlockUser(editedData?.id).unwrap();
      } else {
        response = await blockUser(editedData?.id).unwrap();
      }

      Toast(response?.message, "success");
      setBlockModal(false);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };

  return (
    <div className={styles.MainContainer}>
      {viewModal && (
        <ViewSuperVisorDetailModal
          handleClose={() => setViewModal(false)}
          data={editedData}
          learningMatData={learningMatData}
        />
      )}
      {changePassModal ? (
        <ChangePasswordModal
          handleModalClose={() => setChangePassModal(false)}
          onSubmit={onChangePassSubmit}
          isLoading={isLoadingChangePass}
        />
      ) : (
        ""
      )}

      {blockModal ? (
        <DeleteModal
          handleDeleteModalClose={handleBlockModalClose}
          data={editedData}
          cnfrmtext={
            editedData?.is_blocked === true ? "Unblock User" : "Block User"
          }
          text={editedData?.is_blocked === true ? "Unblock" : "Block"}
          cnfrm={"Confirm"}
          cancel={"Cancel"}
          onDelete={blockUnblockSubmit}
          loading={isLoadingBlock || isLoadingUnBlock}
        />
      ) : (
        ""
      )}

      {deleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleDeleteModalClose}
          data={editedData}
          cnfrmtext={"Delete"}
          text={"Delete"}
          cnfrm={"Confirm"}
          cancel={"Cancel"}
          onDelete={handleDelete}
          loading={isLoadingDelete}
        />
      ) : (
        ""
      )}
      {editedModal ? (
        <AddSuperVisorModal
          data={editedData}
          handleClose={() => {
            setEditedModal(false);
            setImagePreview(null);
            setFinalImage(null);
            setEditedData(null);
          }}
          onSubmit={onUpdateSuperVisor}
          imagePreview={imagePreview}
          setImagePreview={setImagePreview}
          setFinalImage={setFinalImage}
          finalImage={finalImage}
          isLoadingSubmit={isLoadingUpdate}
          learningMatData={learningMatData}
          control={control}
          handleSubmit={handleSubmit}
          setValue={setValue}
        />
      ) : (
        ""
      )}

      {addModal ? (
        <AddSuperVisorModal
          handleClose={() => {
            setAddModal(false);
            setPreview(null);
          }}
          onSubmit={onAddSuperVisor}
          imagePreview={imagePreview}
          setImagePreview={setImagePreview}
          setFinalImage={setFinalImage}
          finalImage={finalImage}
          isLoadingSubmit={isLoadingAdd}
          learningMatData={learningMatData}
          control={control}
          handleSubmit={handleSubmit}
        />
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div className="d-flex justify-content-between w-100">
          <div>
            <SubTitle text={"Supervisor Management"} classes="" />
          </div>
          <div className="d-flex align-items-center gap-2 ms-auto">
            <div className={styles.search}>
              <div className={styles.searchButton}>
                <AiOutlineSearch />
              </div>
              <input
                type="text"
                placeholder="Search "
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <AddButton
              text="Add Supervisor"
              onClick={() => {
                setAddModal(true);
                setPreview(null);
                setEditedData(null);
                reset();
              }}
            />
          </div>
        </div>
      </div>

      <div className={styles.mainTable}>
        {isLoading ? (
          <CustomSpinner />
        ) : (
          <Table
            data={rowData}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
          />
        )}
      </div>
    </div>
  );
};

export default SupervisorManagement;
